import { useState, useEffect, useCallback } from 'react';

const decode = (parts) => parts.join('');

export const ProtectedEmail = ({ user, domain, className = '' }) => {
  const [revealed, setRevealed] = useState(false);
  const [addr, setAddr] = useState('');

  useEffect(() => {
    setAddr(decode([user, '@', domain]));
  }, [user, domain]);

  const handleClick = useCallback((e) => {
    e.preventDefault();
    if (addr) window.location.href = decode(['ma', 'il', 'to', ':', addr]);
  }, [addr]);

  return (
    <a
      href="#contact"
      onClick={handleClick}
      onMouseEnter={() => setRevealed(true)}
      className={className}
      data-testid="protected-email"
      aria-label="Indirizzo email"
    >
      {revealed || addr ? addr : `${user}[at]${domain}`}
    </a>
  );
};

export const ProtectedPhone = ({ parts, display, className = '' }) => {
  const [number, setNumber] = useState('');

  useEffect(() => {
    setNumber(parts.join(''));
  }, [parts]);

  const handleClick = useCallback((e) => {
    e.preventDefault();
    if (number) window.location.href = `tel:${number}`;
  }, [number]);

  return (
    <a
      href="#contact"
      onClick={handleClick}
      className={className}
      data-testid="protected-phone"
      aria-label="Numero di telefono"
    >
      {display || number}
    </a>
  );
};
